module.exports = __webpack_public_path__ + "static/img/已核销.2bb0738b.png";